<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new bond</small>
      </legend>
      <div>
        <div class="row">
          <div class="col-md-12">
            <fieldset class="border p-3">
              <label for="fullnames" style="font-size:13px; font-weight: bold">Cargo number:</label>
              <span style="font-size:13px;">{{Custombond.container_no}}</span>
            </fieldset>
          </div>
        </div>
        <p></p>
        <p></p>
        <form @submit.prevent="newBond()">
          <div class="row">
            <input type="hidden" class="fileopening_id" :value="Custombond.fileopening_id" />
            <input type="hidden" class="cargo_id" :value="Custombond.id" />
            <div class="col-md-6">
              <div class="form-group">
                <label>Bond Amount</label>
                <input
                  type="number"
                  class="form-control bond_amount input-rounded f-s-14"
                  placeholder="bond amount"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>T812 Entry</label>
                <input
                  type="number"
                  class="form-control t812_entry input-rounded f-s-14"
                  placeholder="t812 entry"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingBond btn-rounded">
            <i class="fa fa-plus"></i> create bond
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingBondLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Custombond.length === 0) {
      router.push("/managecustombonds");
    }
  },
  computed: {
    ...mapGetters(["Custombond"])
  },
  methods: {
    ...mapActions(["newBond"])
  }
};
</script>
<style scoped>
.creatingBondLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/bonds/bond.vue